<template>

<div id="topbar" class="topbar section-white">

  <div class="topbar-left-side">

    <div class="topbar-logo">

      <router-link to="/">
        <Qimage name="logo.png"/>
      </router-link>

    </div>

  </div>

  <div class="topbar-right-side">

    <div class="topbar-dropdown">

      <Dropdown
        id="topbar-lang"
        :title="currentLang"
        backwards="true"
        :click="changeLang"
        :items="[
          { text: 'EN', clickValue: 'en' },
          { text: 'ES', clickValue: 'es' }
        ]"/>

    </div>

    <div class="topbar-dropdown">

      <Dropdown
        id="topbar-menu"
        :title="$t('topbar.menu.title')"
        backwards="true"
        :click="navigate"
        :items="[
          { text: $t('topbar.menu.items.item01'), clickValue: 'ethics' },
          { text: $t('topbar.menu.items.item02'), clickValue: '#slide08' }
        ]"/>

    </div>

  </div>

</div>

</template>

<script>
import Qimage from './general/elements/Qimage.vue'
import Dropdown from './general/elements/Dropdown.vue'

export default {
  name: 'Topbar',
  components: {
    Qimage,
    Dropdown
  },
  computed: {
    currentLang: function() {
      try {
        return this.$parent.$locale.toUpperCase()
      }
      catch(e) {
        return 'en'
      }
    }
  },
  methods: {
    changeLang: function(lang) {
      this.$parent.$locale = lang
    },
    navigate: function(event) {
      location.href = location.origin + '/#/' + event
    }
  }
}
</script>

<style lang="scss" scoped>
.topbar {
  width:80%;
  height: -webkit-fit-content;
  height: -moz-fit-content;
  height: fit-content;
  border-bottom: 1px solid #171c33;
  padding: 10px 10%;
  margin: auto;

  .topbar-left-side {
    width: 50%;
    display: inline-block;

    .topbar-logo {
      margin: 0 25px;

      img {
        height: 50px;
      }
    }
  }

  .topbar-right-side {
    width: 50%;
    text-align: right;
    display: inline-block;
    vertical-align: bottom;

    .topbar-dropdown {
      display: inline-block;
      text-align: left;
      vertical-align: super;
      padding: 10px 0;
      margin: 0 15px;
    }
  }
}

@media (max-width: 500px), (max-device-width: 500px) {
  .topbar {
    width: 100%;
    padding: 10px 0;
  }
}

@media (max-width: 450px), (max-device-width: 450px) {
  .topbar {
    margin: 0 !important;

    .topbar-left-side {
      .topbar-logo {
        img {
          margin: 0;
        }
      }
    }

    .topbar-right-side {
      .topbar-dropdown {
        margin: 0 5px;
      }
    }
  }
}

@media (max-width: 350px), (max-device-width: 350px) {
  .topbar {
    .topbar-left-side {
      width: 60%;
    }

    .topbar-right-side {
      width: 40%;
    }
  }
}
</style>
